import "./Footer.scss";
import GitHubLogo from "../../images/github-logo.svg";
import LinkedInLogo from "../../images/linkedin-logo.svg";

const Footer = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return (
    <footer className="footer__container">
      <div className="footer__content">
        <div className="footer__get-in-touch">
          <h2 className="footer__title">Let's Connect!</h2>
          <p className="footer__subtitle">
            Feel free to reach out through any of these platforms
          </p>

          <div className="footer__social-links">
            <a
              className="footer__social-link"
              href="https://github.com/Zakariyya98"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub Profile"
            >
              <img
                className="footer__social-icon"
                src={GitHubLogo}
                alt="GitHub"
              />
              <span className="footer__social-text">Zakariyya98</span>
            </a>

            <a
              className="footer__social-link"
              href="https://www.linkedin.com/in/ahmedzak1/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn Profile"
            >
              <img
                className="footer__social-icon"
                src={LinkedInLogo}
                alt="LinkedIn"
              />
              <span className="footer__social-text">Zakariyya Ahmed</span>
            </a>
          </div>
        </div>

        <div className="footer__divider"></div>

        <div className="footer__copyright">
          <p>© {currentYear} Zakariyya Ahmed. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
